module.exports = __webpack_public_path__ + "static/media/error.94707759.svg";